import { DateTime } from "luxon"
import { create } from "zustand"
import { persist } from 'zustand/middleware'


export type PostHsTitle = {
  titleTypeCompleted?: string
  titleSchoolCompleted?: string
  titleSchoolCompletedAddressString?: string
  titleSchoolCompletedAddressCity?: string
  titleSchoolCompletedAddressProvince?: string
  titleSchoolCompletedAddressCountry?: string
  courseCompleted?: string
  yearAtCompleted?: string
  gradeCompleted?: number
  laudeCompleted?: boolean
}

export type FormInitialStoreState = {
  landedAt?: DateTime
  isAnonymous?: boolean
  userInfo?: any
  completedQuestions: Array<string>
  formBeginAt?: DateTime
  firstName?: string
  lastName?: string
  birthday?: Date
  email?: string
  domicileProvince?: string
  italianResidence?: boolean
  isHsDone?: boolean
  hsYearAt?: number
  hsSchool?: string
  hsSchoolString?: string
  hsSchoolEnrolled?: string
  hsSchoolEnrolledString?: string
  hsSchoolAddressString?: string,
  hsSchoolAddressCity?: string,
  hsSchoolAddressProvince?: string,
  hsSchoolAddressCountry?: string,
  hsSchoolAddressStringEnrolled?: string,
  hsSchoolAddressCityEnrolled?: string,
  hsSchoolAddressProvinceEnrolled?: string,
  hsSchoolAddressCountryEnrolled?: string,
  hsSchoolCourseType?: string
  hsSchoolCourseTypeString?: string
  hsSchoolCourseTypeEnrolled?: string
  hsSchoolCourseTypeEnrolledString?: string
  hsSchoolGraduationYear?: string
  hsSchoolGrade?: number
  hsSchoolGradeLaude?: boolean

  hasPostHsTitles: number
  postHsTitles: Array<PostHsTitle> 
  postHsSchoolTitleTypeEnrolled?: string

  // IsKnowWhatStudy
  isKnowWhatStudy: boolean,

  // LatestTitle
  latestTitle?: string,

  // StudyWhere
  hasTitles: number
  schoolTitles: Array<PostHsTitle> 
  schoolTitleTypeEnrolled?: string

  postHsSchoolTitleSchoolEnrolled?: string
  postHsSchoolTitleSchoolEnrolledString?: string
  postHsSchoolTitleSchoolEnrolledAddressString?:string
  postHsSchoolTitleSchoolEnrolledAddressCity?:string
  postHsSchoolTitleSchoolEnrolledAddressProvince?:string
  postHsSchoolTitleSchoolEnrolledAddressCountry?:string
  postHsSchoolCourseEnrolled?: string
  postHsSchoolCourseEnrolledString?: string
  postHsSchoolYearAtEnrolled?: string
  isEnrolledPostHsSchool?: boolean
  interestsOpen?: string
  interests?: Array<string>
  subInterests?: Array<string>
  subInterestsGrade?: number
  futureStepSchoolType?: string
  futureStepSchoolTypeGrade?: number
  futureStepWhere?: string
  futureStepWhereGrade?: number
  futureStepWorkType?: string
  futureStepAreaWorkValue?: string
  futureStepWorkOpen?: string
  futureStepWorkValue?: string
  futureStepWorkGrade?: number
  formEndAt?: DateTime
}

type FormInitialStoreActions = {
  setLandedAt: (value: DateTime) => void
  setIsAnonymous: (value: boolean) => void
  setUserInfo: (value: any) => void
  setCompletedQuestions: (value: Array<string>) => void
  addCompletedQuestion: (question: string) => void 
  
  setFormBeginAt: (value: DateTime) => void

  setFirstName: (value: string) => void
  setLastName: (value: string) => void
  // setBirthYear: (value: number) => void
  setBirthday: (value: Date) => void
  setEmail: (value: string) => void
  setDomicileProvince: (value: string) => void
  setItalianResidence: (value: boolean) => void
  setIsHsDone: (value: boolean) => void
  setHsYearAt: (value: number) => void
  setHsSchool: (value: string) => void
  setHsSchoolString: (value: string) => void
  setHsSchoolAddressString: (value: string) => void
  setHsSchoolAddressCity: (value: string) => void
  setHsSchoolAddressProvince: (value: string) => void
  setHsSchoolAddressCountry: (value: string) => void
  
  setHsSchoolEnrolled: (value: string) => void
  setHsSchoolEnrolledString: (value: string) => void

  setHsSchoolAddressStringEnrolled: (value: string) => void
  setHsSchoolAddressCityEnrolled: (value: string) => void
  setHsSchoolAddressProvinceEnrolled: (value: string) => void
  setHsSchoolAddressCountryEnrolled: (value: string) => void


  setHsSchoolCourseType: (value: string) => void
  setHsSchoolCourseTypeString: (value: string) => void
  setHsSchoolCourseTypeEnrolled: (value: string) => void
  setHsSchoolCourseTypeEnrolledString: (value: string) => void
  setHsSchoolGraduationYear: (value: string) => void
  setHsSchoolGrade: (value: number) => void
  setHsSchoolGradeLaude: (value: boolean) => void
  setHasPostHsTitles: (value: number) => void
  setIsKnowWhatStudy: (value: boolean) => void

  setHasTitles: (value: number) => void


  addPostHsTitle: () => void
  updatePostHsTitle: (index: number, updatedTitle: PostHsTitle) => void
  removePostHsTitle: (index: number) => void
  
  setPostHsSchoolTitleTypeCompleted: (index: number, value: string) => void
  setPostHsSchoolTitleTypeEnrolled: (value: string) => void

  setSchoolTitleTypeCompleted: (index: number, value: string) => void
  setSchoolTitleTypeEnrolled: (value: string) => void

  setLatestTitleCompleted: (value: string) => void

  setPostHsSchoolTitleSchoolCompleted: (index: number, value: string) => void
  setPostHsSchoolTitleSchoolCompletedAddressString: (index: number, value: string) => void
  setPostHsSchoolTitleSchoolCompletedAddressCity: (index: number, value: string) => void
  setPostHsSchoolTitleSchoolCompletedAddressProvince: (index: number, value: string) => void
  setPostHsSchoolTitleSchoolCompletedAddressCountry: (index: number, value: string) => void
  
  setPostHsSchoolCourseCompleted: (index: number, value: string) => void
  setPostHsSchoolYearAtCompleted: (index: number, value: string) => void
  setPostHsSchoolGradeCompleted: (index: number, value: number) => void
  setPostHsSchoolGradeLaudeCompleted: (index: number, value: boolean) => void

  setPostHsSchoolTitleSchoolEnrolled: (value: string) => void
  setPostHsSchoolTitleSchoolEnrolledString: (value: string) => void

  setPostHsSchoolTitleSchoolEnrolledAddressString:(value: string)=>void
  setPostHsSchoolTitleSchoolEnrolledAddressCity:(value: string)=>void
  setPostHsSchoolTitleSchoolEnrolledlAddressProvince:(value: string)=>void
  setPostHsSchoolTitleSchoolEnrolledAddressCountry:(value: string)=>void

  setPostHsSchoolCourseEnrolled: (value: string) => void
  setPostHsSchoolCourseEnrolledString: (value: string) => void
  setPostHsSchoolYearAtEnrolled: (value: string) => void
  setIsEnrolledPostHsSchool: (value: boolean) => void

  setInterestsOpen: (value: string) => void
  setInterests: (value: Array<string>) => void
  setSubInterests: (value: Array<string>) => void
  setSubInterestsGrade: (value: number) => void
  setFutureStepSchoolType: (value: string) => void
  setFutureStepSchoolTypeGrade: (value: number) => void
  setFutureStepWhere: (value: string) => void
  setFutureStepWhereGrade: (value: number) => void
  setFutureStepWorkType: (value: string) => void
  setFutureStepAreaWorkValue: (value: string) => void
  setFutureStepWorkValue: (value: string) => void
  setFutureStepWorkGrade: (value: number) => void

  setFutureStepWorkOpen: (value: string) => void

  setFormEndAt: (value: DateTime) => void

  reset: () => void
}
// define the initial state
export const initialFormInitialStoreState: FormInitialStoreState = {
  landedAt: undefined,
  isAnonymous: undefined,
  userInfo: undefined,
  completedQuestions: [],
  formBeginAt: undefined,
  firstName: undefined,
  lastName: undefined,
  birthday: undefined,
  email: undefined,
  domicileProvince: undefined,
  italianResidence: undefined,
  isHsDone: undefined,
  hsYearAt: undefined,
  hsSchool: undefined,
  hsSchoolString: undefined,
  hsSchoolEnrolled: undefined,
  hsSchoolEnrolledString: undefined,

  hsSchoolAddressString:undefined,
  hsSchoolAddressCity: undefined,
  hsSchoolAddressProvince:undefined,
  hsSchoolAddressCountry:undefined,

  hsSchoolAddressStringEnrolled:undefined,
  hsSchoolAddressCityEnrolled:undefined,
  hsSchoolAddressProvinceEnrolled:undefined,
  hsSchoolAddressCountryEnrolled:undefined,

  hsSchoolCourseType: undefined,
  hsSchoolCourseTypeString: undefined,
  hsSchoolCourseTypeEnrolled: undefined,
  hsSchoolCourseTypeEnrolledString: undefined,
  hsSchoolGraduationYear: undefined,
  hsSchoolGrade: undefined,
  hsSchoolGradeLaude: undefined,

  hasPostHsTitles: 0,
  postHsTitles: [],
  postHsSchoolTitleTypeEnrolled: undefined,

  // IsKnowWhatStudy
  isKnowWhatStudy: false,

  // LatestTitle
  latestTitle: undefined,

  // StudyWhere
  hasTitles: 0,
  schoolTitles: [],
  schoolTitleTypeEnrolled: undefined,

  postHsSchoolTitleSchoolEnrolled: undefined,
  postHsSchoolTitleSchoolEnrolledString: undefined,
  postHsSchoolTitleSchoolEnrolledAddressString: undefined,
  postHsSchoolTitleSchoolEnrolledAddressCity:undefined,
  postHsSchoolTitleSchoolEnrolledAddressProvince:undefined,
  postHsSchoolTitleSchoolEnrolledAddressCountry:undefined,

  postHsSchoolCourseEnrolled: undefined,
  postHsSchoolCourseEnrolledString: undefined,
  postHsSchoolYearAtEnrolled: undefined,
  isEnrolledPostHsSchool: undefined,
  interestsOpen: undefined,
  interests: undefined,
  subInterests: undefined,
  subInterestsGrade: undefined,
  futureStepSchoolType: undefined,
  futureStepSchoolTypeGrade: undefined,
  futureStepWhere: undefined,
  futureStepWhereGrade: undefined,
  futureStepWorkType: undefined,
  futureStepAreaWorkValue: undefined,
  futureStepWorkValue: undefined,
  futureStepWorkGrade: undefined,
  futureStepWorkOpen: undefined,
  formEndAt: undefined,
}

const useFormInitialStore = create<FormInitialStoreState & FormInitialStoreActions>()(
  persist(
    (set, get) => ({
      ...initialFormInitialStoreState,
      setLandedAt: value => set({ landedAt: value }),
      setIsAnonymous: value => set({ isAnonymous: value }),
      setUserInfo: value => set({ userInfo: value }),
      setCompletedQuestions: value => set({ completedQuestions: value }),
      addCompletedQuestion: question => set(state => ({ completedQuestions: [...state.completedQuestions, question] })),
      setFormBeginAt: value => set({ formBeginAt: value }),

      setFirstName: value => set({ firstName: value }),
      setLastName: value => set({ lastName: value }),
      setBirthday: value => set({ birthday: value }),
      setEmail: value => set({ email: value }),
      setDomicileProvince: value => set({ domicileProvince: value }),
      setItalianResidence: value => set({ italianResidence: value }),
      setIsHsDone: value => set({ isHsDone: value }),
      setHsYearAt: value => set({ hsYearAt: value }),
      setHsSchool: value => set({ hsSchool: value }),
      setHsSchoolString: value => set({ hsSchoolString: value }),
      setHsSchoolEnrolled: value => set({ hsSchoolEnrolled: value }),
      setHsSchoolEnrolledString: value => set({ hsSchoolEnrolledString: value }),

      setHsSchoolAddressString: value => set({hsSchoolAddressString:value}),
      setHsSchoolAddressCity: value => set({hsSchoolAddressCity:value}),
      setHsSchoolAddressProvince: value => set({hsSchoolAddressProvince:value}),
      setHsSchoolAddressCountry: value => set({hsSchoolAddressCountry:value}),
      setHsSchoolAddressStringEnrolled: value => set({hsSchoolAddressStringEnrolled:value}),
      setHsSchoolAddressCityEnrolled: value => set({hsSchoolAddressCityEnrolled:value}),
      setHsSchoolAddressProvinceEnrolled: value => set({hsSchoolAddressProvinceEnrolled:value}),
      setHsSchoolAddressCountryEnrolled: value => set({hsSchoolAddressCountryEnrolled:value}),
      setHsSchoolCourseType: value => set({ hsSchoolCourseType: value }),
      setHsSchoolCourseTypeString: value => set({ hsSchoolCourseTypeString: value }),
      setHsSchoolCourseTypeEnrolled: value => set({ hsSchoolCourseTypeEnrolled: value }),
      setHsSchoolCourseTypeEnrolledString: value => set({ hsSchoolCourseTypeEnrolledString: value }),
      setHsSchoolGraduationYear: value => set({ hsSchoolGraduationYear: value }),
      setHsSchoolGrade: value => set({ hsSchoolGrade: value }),
      setHsSchoolGradeLaude: value => set({ hsSchoolGradeLaude: value }),

      setHasPostHsTitles: value => set(state => { 
        const postHsTitles = [...state.postHsTitles]
        for (let i=postHsTitles.length; i<value;i++){
          postHsTitles.push({});
        }
       return { hasPostHsTitles: value, postHsTitles: postHsTitles }
      }),

      // StudyWhere
      setHasTitles: value => set(state => { 
        const schoolTitles = [...state.schoolTitles]
        for (let i=schoolTitles.length; i<value;i++){
          schoolTitles.push({});
        }
       return { hasTitles: value, schoolTitles: schoolTitles }
      }),

      setIsKnowWhatStudy: (value: boolean) => set({ isKnowWhatStudy: value }),

      setPostHsSchoolTitleTypeCompleted: (index: number, value: string) => set(state => {
        const postHsTitles = [...state.postHsTitles]
        postHsTitles[index-1].titleTypeCompleted = value;
        return { postHsTitles: postHsTitles}
      }),
      
      setSchoolTitleTypeCompleted: (index: number, value: string) => set(state => {
        const schoolTitles = [...state.schoolTitles]
        schoolTitles[index-1].titleTypeCompleted = value;
        return { schoolTitles: schoolTitles}
      }),
      setSchoolTitleTypeEnrolled: value => set({ postHsSchoolTitleTypeEnrolled: value }),

      setLatestTitleCompleted: (value: string) => set({ latestTitle: value }),

      setPostHsSchoolTitleSchoolCompleted: (index: number, value: string) => set(state => {
        const postHsTitles = [...state.postHsTitles]
        postHsTitles[index-1].titleSchoolCompleted = value;
        return { postHsTitles: postHsTitles}
      }),

      setPostHsSchoolTitleSchoolCompletedAddressString: (index: number, value: string) => set(state => {
        const postHsTitles = [...state.postHsTitles]
        postHsTitles[index-1].titleSchoolCompletedAddressString = value;
        return { postHsTitles: postHsTitles}
      }),

      setPostHsSchoolTitleSchoolCompletedAddressCity: (index: number, value: string) => set(state => {
        const postHsTitles = [...state.postHsTitles]
        postHsTitles[index-1].titleSchoolCompletedAddressCity = value;
        return { postHsTitles: postHsTitles}
      }),

      setPostHsSchoolTitleSchoolCompletedAddressProvince: (index: number, value: string) => set(state => {
        const postHsTitles = [...state.postHsTitles]
        postHsTitles[index-1].titleSchoolCompletedAddressProvince = value;
        return { postHsTitles: postHsTitles}
      }),

      setPostHsSchoolTitleSchoolCompletedAddressCountry: (index: number, value: string) => set(state => {
        const postHsTitles = [...state.postHsTitles]
        postHsTitles[index-1].titleSchoolCompletedAddressCountry = value;
        return { postHsTitles: postHsTitles}
      }),

      setPostHsSchoolCourseCompleted: (index: number, value: string) => set(state => {
        const postHsTitles = [...state.postHsTitles]
        postHsTitles[index-1].courseCompleted = value;
        return { postHsTitles: postHsTitles}
      }),

      setPostHsSchoolYearAtCompleted: (index: number, value: string) => set(state => {
        const postHsTitles = [...state.postHsTitles]
        postHsTitles[index-1].yearAtCompleted = value;
        return { postHsTitles: postHsTitles}
      }),
      
      setPostHsSchoolGradeCompleted: (index: number, value:number) => set(state => {
        const postHsTitles = [...state.postHsTitles]
        postHsTitles[index-1].gradeCompleted = value;
        return { postHsTitles: postHsTitles}
      }),
      setPostHsSchoolGradeLaudeCompleted: (index: number, value:boolean) => set(state => {
        const postHsTitles = [...state.postHsTitles]
        postHsTitles[index-1].laudeCompleted = value;
        return { postHsTitles: postHsTitles}
      }),


      // Post HS Titles Management
      addPostHsTitle: () => set(state => ({
        postHsTitles: [...(state.postHsTitles || []), {}]
      })),

      updatePostHsTitle: (index, updatedTitle) => set(state => {
        const postHsTitles = state.postHsTitles ? [...state.postHsTitles] : []
        postHsTitles[index] = { ...postHsTitles[index], ...updatedTitle }
        return { postHsTitles }
      }),
      removePostHsTitle: (index) => set(state => ({
        postHsTitles: state.postHsTitles ? state.postHsTitles.filter((_, i) => i !== index) : []
      })),
      
      setPostHsSchoolTitleTypeEnrolled: value => set({ postHsSchoolTitleTypeEnrolled: value }),
      
      setPostHsSchoolTitleSchoolEnrolled: value => set({ postHsSchoolTitleSchoolEnrolled: value }),
      setPostHsSchoolTitleSchoolEnrolledString: value => set({ postHsSchoolTitleSchoolEnrolledString: value }),

      setPostHsSchoolTitleSchoolEnrolledAddressString:value=> set({postHsSchoolTitleSchoolEnrolledAddressString:value}),
      setPostHsSchoolTitleSchoolEnrolledAddressCity:value=> set({postHsSchoolTitleSchoolEnrolledAddressCity:value}),
      setPostHsSchoolTitleSchoolEnrolledlAddressProvince:value=> set({postHsSchoolTitleSchoolEnrolledAddressProvince:value}),
      setPostHsSchoolTitleSchoolEnrolledAddressCountry:value=> set({postHsSchoolTitleSchoolEnrolledAddressCountry:value}),
      
      setPostHsSchoolCourseEnrolled: value => set({ postHsSchoolCourseEnrolled: value }),
      setPostHsSchoolCourseEnrolledString: value => set({ postHsSchoolCourseEnrolledString: value }),
      setPostHsSchoolYearAtEnrolled: value => set({ postHsSchoolYearAtEnrolled: value }),


      setIsEnrolledPostHsSchool: value => set({ isEnrolledPostHsSchool: value }),
      setInterestsOpen: value => set({ interestsOpen: value }),
      setInterests: value => set({ interests: value }),
      setSubInterests: value => set({ subInterests: value }),
      setSubInterestsGrade: value => set({ subInterestsGrade: value }),
      setFutureStepSchoolType: value => set({ futureStepSchoolType: value }),
      setFutureStepSchoolTypeGrade: value => set({ futureStepSchoolTypeGrade: value }),
      setFutureStepWhere: value => set({ futureStepWhere: value }),
      setFutureStepWhereGrade: value => set({ futureStepWhereGrade: value }),
      setFutureStepWorkType: value => set({ futureStepWorkType: value }),
      setFutureStepAreaWorkValue: value => set({ futureStepAreaWorkValue: value }),
      setFutureStepWorkValue: value => set({ futureStepWorkValue: value }),
      setFutureStepWorkGrade: value => set({ futureStepWorkGrade: value }),
      setFutureStepWorkOpen: value => set({ futureStepWorkOpen: value }),
      setFormEndAt: value => set({ formEndAt: value }),
      
      reset: () => set(initialFormInitialStoreState)
    }),
    {
      name: 'form_initial'
    }
  )
);

export const getFromPostHsSchool = (index:number, postHsTitles: Array<PostHsTitle>) => {
  if (postHsTitles.length < index) {
    return undefined
  }
  return postHsTitles[index-1];
}

export default useFormInitialStore;
